/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc
 */
import * as References from './PortalLayoutRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#listBlockDefinitions
 */
export const LIST_BLOCK_DEFINITIONS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_listBlockDefinitions';
export const LIST_BLOCK_DEFINITIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_BLOCK_DEFINITIONS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.listBlockDefinitionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#listEmbeddableBreezeArtifacts
 */
export const LIST_EMBEDDABLE_BREEZE_ARTIFACTS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_listEmbeddableBreezeArtifacts';
export const LIST_EMBEDDABLE_BREEZE_ARTIFACTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_EMBEDDABLE_BREEZE_ARTIFACTS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.listEmbeddableBreezeArtifactsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#createBreezeArtifactShareLink
 */
export const CREATE_BREEZE_ARTIFACT_SHARE_LINK_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_createBreezeArtifactShareLink';
export const CREATE_BREEZE_ARTIFACT_SHARE_LINK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_BREEZE_ARTIFACT_SHARE_LINK_MUTATION_FIELD_NAME,
  args: ['artifactId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.createBreezeArtifactShareLinkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#listLayouts
 */
export const LIST_LAYOUTS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_listLayouts';
export const LIST_LAYOUTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_LAYOUTS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.listLayoutsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#reorderLayouts
 */
export const REORDER_LAYOUTS_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_reorderLayouts';
export const REORDER_LAYOUTS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REORDER_LAYOUTS_MUTATION_FIELD_NAME,
  args: ['layoutKeys', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.reorderLayoutsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#getLayout
 */
export const GET_LAYOUT_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_getLayout';
export const GET_LAYOUT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LAYOUT_QUERY_FIELD_NAME,
  args: ['layoutKey', 'draft', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getLayoutRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#saveDraft
 */
export const SAVE_DRAFT_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_saveDraft';
export const SAVE_DRAFT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SAVE_DRAFT_MUTATION_FIELD_NAME,
  args: ['blocks', 'layoutKey', 'label', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.saveDraftRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#publish
 */
export const PUBLISH_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_publish';
export const PUBLISH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: PUBLISH_MUTATION_FIELD_NAME,
  args: ['layoutKey', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.publishRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#saveLayout
 */
export const SAVE_LAYOUT_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_saveLayout';
export const SAVE_LAYOUT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SAVE_LAYOUT_MUTATION_FIELD_NAME,
  args: ['blocks', 'layoutKey', 'label', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.saveLayoutRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#deleteLayout
 */
export const DELETE_LAYOUT_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_deleteLayout';
export const DELETE_LAYOUT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_LAYOUT_MUTATION_FIELD_NAME,
  args: ['layoutKey', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.deleteLayoutRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#listTemplates
 */
export const LIST_TEMPLATES_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_listTemplates';
export const LIST_TEMPLATES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_TEMPLATES_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.listTemplatesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#getTemplate
 */
export const GET_TEMPLATE_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_getTemplate';
export const GET_TEMPLATE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TEMPLATE_QUERY_FIELD_NAME,
  args: ['templateKey', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.getTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#saveTemplate
 */
export const SAVE_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_saveTemplate';
export const SAVE_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SAVE_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['templateKey', 'label', 'description', 'blocks', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.saveTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#deleteTemplate
 */
export const DELETE_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_deleteTemplate';
export const DELETE_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['templateKey', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.deleteTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#createLayoutFromTemplate
 */
export const CREATE_LAYOUT_FROM_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_createLayoutFromTemplate';
export const CREATE_LAYOUT_FROM_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_LAYOUT_FROM_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['templateKey', 'layoutKey', 'label', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.createLayoutFromTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc#saveLayoutAsTemplate
 */
export const SAVE_LAYOUT_AS_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalLayoutRpc_saveLayoutAsTemplate';
export const SAVE_LAYOUT_AS_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SAVE_LAYOUT_AS_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['layoutKey', 'templateKey', 'label', 'description', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.saveLayoutAsTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});